import { useEffect } from "react";
import { useNavigationType } from "react-router-dom";
import HeroSection from "./PagesComps/HeroSection";
import FeaturedWork from "./PagesComps/FeaturedWork";
import ExperienceSection from "./PagesComps/ExperienceSection";
import { smoothScrollTo } from "../components/smoothScroll";
import { useSettings } from "../data/content";

function Home({ darkMode }) {
  const settings = useSettings();
  const navType = useNavigationType();

  useEffect(() => {
    if (settings.siteTitle) document.title = settings.siteTitle;
  }, [settings.siteTitle]);

  useEffect(() => {
    const savedY = sessionStorage.getItem("workScrollY");
    if (savedY === null) return;
    if (navType !== "POP") {
      sessionStorage.removeItem("workScrollY");
      return;
    }
    const y = parseInt(savedY, 10);
    window.scrollTo({ top: 0, behavior: "instant" });
    let raf1, raf2;
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        sessionStorage.removeItem("workScrollY");
        smoothScrollTo(y);
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main>
      <HeroSection darkMode={darkMode} />
      <FeaturedWork />
      <ExperienceSection darkMode={darkMode} />
    </main>
  );
}

export default Home;
